/**
 * Created by AlexanderC on 2/22/17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackendContext = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractContext2 = require('./AbstractContext');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let BackendContext = exports.BackendContext = function (_AbstractContext) {
  _inherits(BackendContext, _AbstractContext);

  function BackendContext() {
    _classCallCheck(this, BackendContext);

    return _possibleConstructorReturn(this, (BackendContext.__proto__ || Object.getPrototypeOf(BackendContext)).apply(this, arguments));
  }

  _createClass(BackendContext, null, [{
    key: 'fromKernel',

    /**
     * @param {Kernel|*} kernel
     *
     * @returns {AbstractContext|*}
     */
    value: function fromKernel(kernel) {
      const runtimeContext = BackendContext._filterRuntimeContext(kernel.runtimeContext);

      return new this(runtimeContext);
    }

    /**
     * @param {*} runtimeContext
     * 
     * @returns {*}
     *
     * @private
     */

  }, {
    key: '_filterRuntimeContext',
    value: function _filterRuntimeContext(runtimeContext) {
      const context = {};

      Object.keys(runtimeContext).forEach(key => {
        const value = runtimeContext[key];

        if (BackendContext._isScalarOrArray(value)) {
          context[key] = value;
        } else if (typeof value === 'object') {
          if (Object.keys(value).length <= 0) {
            context[key] = value;
          } else {
            const plainValue = BackendContext._filterRuntimeContext(value);

            if (Object.keys(plainValue).length > 0) {
              context[key] = plainValue;
            }
          }
        }
      });

      return context;
    }

    /**
     * @param {*} value
     * 
     * @returns {Boolean}
     *
     * @private
     */

  }, {
    key: '_isScalarOrArray',
    value: function _isScalarOrArray(value) {
      return null === value || Array.isArray(value) || /string|number|boolean/i.test(typeof value);
    }
  }]);

  return BackendContext;
}(_AbstractContext2.AbstractContext);


//////////////////
// WEBPACK FOOTER
// ../~/deep-event/lib.compiled/Context/BackendContext.js
// module id = 169
// module chunks = 0